import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import DialogProvider from "@components/dialog_provider"
import { useUserPageContext } from "@contexts/main/users_page_context"
import { deleteUsers } from "@domain/users"
import useControlledForm from "@hooks/use_controlled_form"
import { useQueryClient } from "@tanstack/react-query"
import { showErrorToast } from "@utils/toast"

export default function DeleteUser({
  isOpen,
  setClose,
  selectedRowId
}: {
  isOpen: boolean
  setClose: () => void
  selectedRowId: string
}) {
  const { translate, setUsersData } = useUserPageContext()
  const [loading, setLoading] = useState(false)
  const queryClient = useQueryClient()

  const {
    formState: { isValid }
  } = useControlledForm({
    mode: "all"
  })

  function handleClose() {
    if (loading) {
      return
    }
    setClose()
  }

  async function onSubmit() {
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await deleteUsers({ _id: selectedRowId })
    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    const response = responseData.data
    if (!response._id) {
      return
    }

    setUsersData?.((prevUsersData) =>
      prevUsersData.filter((item) => item._id !== selectedRowId)
    )
    queryClient.invalidateQueries({ queryKey: ["users-data-table"] })
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={translate("delete_user")}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: handleClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("delete"),
        color: "error",
        onClick: onSubmit,
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack justifyContent={"center"} alignItems={"center"} flex={1}>
        <Typography align="center">{translate("delete_user_text")}</Typography>
      </Stack>
    </DialogProvider>
  )
}
